import request from '@/utils/request';

/**获取所有商品分类tree结构 */
export const productCategoryList = () => {
  return request
    .get('/api/Product/category/list', {})
}

/**获取品牌列表 */
export const productBrandList = () => {
  return request
    .get('/api/Product/Brand/List', {})
}

/**商品列表 */
export const productList = (formData?: any) => {
  return request.get(
    '/api/Product/List',
    {
      ...formData
    });
};

/**商品列表 有判断权限 */
export const productNoPermissionList = (formData?: any) => {
  return request.get(
    '/api/Product/All',
    {
      ...formData
    });
};

/*   获取一个分类下面的所有商品个数 */

export const getProductCount = (param?: any) => {
  return request.get(
    '/api/Product/GetProductCountById',
    {
      ...param
    });
};

